import PropTypes from "prop-types";
import { Typography } from "@mui/material";

import { ORIENTATIONS } from "../constants/intxConstants";
import d4DiagramNorthSouth from "./images/other/d4DiagramNorthSouth.png";
import d4DiagramEastWest from "./images/other/d4DiagramEastWest.png";
import { OtherImgMapper } from "./intersectionImageHelper";

const LABEL_HEIGHT = "30px";

export default function D4Diagram({
  EWFacilityName,
  NSFacilityName,
  orientation,
}) {
  const isEW = orientation === ORIENTATIONS.EAST_WEST;
  const style = { maxHeight: "500px", maxWidth: "500px" };
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <div style={{ alignSelf: "flex-start" }}>
        <img
          alt="north compass arrow"
          src={OtherImgMapper.northArrowDg}
          style={{ height: "70px", width: "70px" }}
        />
      </div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
        }}
      >
        {!!EWFacilityName && (
          <Typography
            sx={{
              marginRight: "10px",
              marginTop: LABEL_HEIGHT,
              maxWidth: "110px",
            }}
          >
            {EWFacilityName}
          </Typography>
        )}
        <div style={{ textAlign: "center" }}>
          {!!NSFacilityName && (
            <Typography sx={{ height: LABEL_HEIGHT, marginBottom: "10px" }}>
              {NSFacilityName}
            </Typography>
          )}
          {isEW ? (
            <img
              src={d4DiagramEastWest}
              style={style}
              alt="east west oriented diamond"
            />
          ) : (
            <img
              src={d4DiagramNorthSouth}
              style={style}
              alt="north south oriented diamond"
            />
          )}
        </div>
      </div>
    </div>
  );
}

D4Diagram.propTypes = {
  EWFacilityName: PropTypes.string,
  NSFacilityName: PropTypes.string,
  orientation: PropTypes.oneOf(Object.values(ORIENTATIONS)).isRequired,
};
